// A tuft of tall grass — a few thin green blades fanning out, cosmetic scenery
// to break up open biomes. Ported 1:1 from age-of-mcp's classic tall-grass.ts,
// restoring its radial blade loop and per-variant palette.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(v: number): Part[] {
  const col = v === 0 ? ["#6fae4e", "#7fbf58"] : ["#9bab50", "#aeb95e"];
  const parts: Part[] = [];
  const N = 6;
  for (let i = 0; i < N; i++) {
    const a = (i / N) * Math.PI * 2;
    const hgt = 0.26 + (i % 3) * 0.07;
    const lean = 0.18 + (i % 2) * 0.08;
    parts.push({
      geometry: new THREE.BoxGeometry(0.025, hgt, 0.012),
      color: col[i % 2]!,
      position: [Math.cos(a) * 0.07, hgt / 2, Math.sin(a) * 0.07],
      rotation: [Math.sin(a) * lean, 0, -Math.cos(a) * lean],
    });
  }
  return parts;
}

export const tallGrass = defineModel({
  id: "tall-grass",
  batchId: "standard",
  name: "Tall grass",
  tags: ["scenery","tall","grass","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tall grass.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.26,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => partsFor(0) },
    { id: "variant-1", label: "Variant 2", parts: () => partsFor(1) },
  ],
  animations: [],
});
